import React from "react";
import Accordion from "../components/Accordion";
const Services = () => {
  return (
    <div>
      <h1>Services</h1>
      <Accordion />
    </div>
  );
};

export default Services;
